import { LOAD_FIRST_COVER_TO_BACKGROUND_TYPE } from '../../action-types/ui/loadFirstCoverToBackgroundType';

export const STATE_KEY = 'loadCoverDependOnBgType';

export const loadCoverDependOnBgType = (state = '', action) => {
  switch (action.type) {
    case LOAD_FIRST_COVER_TO_BACKGROUND_TYPE: {
      const { flag } = action;
      return flag;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/loadFirstCoverToBackgroundType.js